import * as React from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
function SvgIconCustomAppleShare({
  title,
  titleId,
  ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="currentColor" fillRule="nonzero">
        <path d="M13.057 4.971L10.03 1.943 7 4.97l-.8-.8L10.029.343l3.828 3.828z" />
        <path d="M9.457 1.143H10.6v12H9.457z" />
        <path d="M15.743 20H4.314A1.684 1.684 0 012.6 18.286V8c0-.971.743-1.714 1.714-1.714h4v1.143h-4c-.343 0-.571.228-.571.571v10.286c0 .343.228.571.571.571h11.429c.343 0 .571-.228.571-.571V8c0-.343-.228-.571-.571-.571h-4V6.286h4c.971 0 1.714.743 1.714 1.714v10.286c0 .971-.743 1.714-1.714 1.714z" />
      </g>
    </svg>
  );
}
export default SvgIconCustomAppleShare;
